// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import car01Icon from "@/assets/icons/car-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Car01IconProps = Omit<IconProps, "name">;

export function Car01Icon(props: Car01IconProps): React.ReactNode {
  return <Icon name={car01Icon} {...props} />;
}
